import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths } from 'src/app/shared/helpers/Drop-down-options';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { getRecordsOptions, getShipNameOptions } from 'src/app/shared/helpers/dropdown-options';

@Component({
  selector: 'app-analytics-dashboard',
  templateUrl: './analytics-dashboard.component.html',
  styleUrls: ['./analytics-dashboard.component.scss']
})
export class AnalyticsDashboardComponent {
 @ViewChild('chartCanvas') chartCanvas:
    | ElementRef<HTMLCanvasElement>
    | undefined;

  showLiveScreen: boolean = true;
  chart: Chart | undefined;
  transformedData: any;
  secondchart!: Chart;
  filterOptions: any = [];
  chartDataSecond: any = [];
  dashboardForm: FormGroup;
  shipnameoptions: string[];
  monthOptions: string[];
  cargooptions: string[] = [];
  tankoptionsData!: string[];
  mergeGraph = [];
  recordsoptions: string[];
  tanks: string[] = [];
  vesselImo: string | null = '';
  vesselName: string | null = '';
  secondchartavg: any;
  avgGraph: boolean = false;
  datasets: any[] = [];
  showMeltPt: boolean = true;
  showLoadTemp: boolean = true;
  showCargoTemp: boolean = true;
  showVoyRange: boolean = true;
  showDischRange: boolean = true;
  showAirTemp = false;
  showSeaTemp = false;
  showForecastTemp = true;
  voyRangMax: any;
  voyRangMin: any;
  disRangMax: any;
  disRangMin: any;
  avgVoyMin: any;
  avgVoyMax: any;
  avgDisMin: any;
  avgDisMax: any;
  avgMeltpt: any;
  avgLoad: any;
  selectedTank: string | null = null;
  meltPt: any;
  tankData: any;
  tankoptions: string[] = [];
  fetchAverageTemp: any;
  transformedApiData: any;
  filteredOptions: any;
  apiData: any;
  loadPort: any;
  cargo: any;
  tankDetailsArray: any;
  dischargePort: any;
  parsedDataTwo: any;
  gaugeData!: any;
  Melt_Pts: any;
  Voy_Range_Max: any;
  Disch_Range_Min: any;
  Disch_Range_Max: any;
  Voy_Range_Min: any;
  Load_Pts: any;
  hideGraph: boolean = true;
  constructor(
    private fb: FormBuilder,
    private commonService: CargoheatingCommonService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private cd: ChangeDetectorRef,
    private overlayService: OverlapService,
        private requestFormService: RequestFormService,
  ) {
    this.dashboardForm = this.fb.group({
      fromDate: [''],
      toDate: [''],
      cosp: [''],
      eosp: [''],
      shipname: [''],
      cargo: [''],
      tanks: ['Avg Temp'],
      records: [''],
      month: [''],
    });
    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.recordsoptions = getRecordsOptions();

  }






  ngOnInit(): void {

    this.vesselImo = localStorage.getItem('vesselImo');
    this.vesselName = localStorage.getItem('vesselName');
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

fetchNewData() {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '430px',
      height: '325px',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.router.navigate(['/ch-home']);
      }
    });
  }
  showImage() {
    const image = document.querySelector('.heat-plan-image');
    if (image) {
      image.classList.add('visible');  
    }
  }


  hideImage() {
    const image = document.querySelector('.heat-plan-image');
    if (image) {
      image.classList.remove('visible');  
    }
  }

  isDarkMode(): boolean {
    return this.requestFormService.isDarkMode();
  }

  printPdf(jsonData: any) {

    this.commonService.printPdf(jsonData).subscribe(
      (response: any) => {
        this.overlayService.showPdf(response);
      },
      (error) => {
        this.toastr.info(ToasterMessages.RecordNotFount);
      });
  }
 
  nextGraphData() {
    this.router.navigate(['/ch-graph']);
  }
  printReport(reportType: string) {

    let jsonData = {
      report_type: reportType,
      vessel_imo: localStorage.getItem('vesselImo'),
      vessel_name: localStorage.getItem('vesselName'),
      month: localStorage.getItem('month'),
    };

    this.printPdf(jsonData)
  }
}

interface TransformedForcastoData {
  [key: string]: dataSecond;
}
interface dataSecond {
  air_temp: number | null;
  sea_water_temp: number | null;
  forcast_temp: number | null;
  master_dates: any;
}